import BlockTitle from "@components/cms/BlockTitle/BlockTitle";
import Editor from "@ui-kit/cms/Editor/Editor";
import Container from "@ui-kit/Container/Container";

import s from "./IframeBlock.module.scss";

const IframeBlock = ({ data, updateField, settings }) => {
  const { title = "" } = data;
  const { blockType } = settings.common;
  const { iframeString } = settings.specific;

  return (
    <Container className={s.container}>
      <Container full={false}>
        <section>
          <BlockTitle
            settings={settings}
            field={{ title }}
            onChange={updateField}
            type={blockType}
          />
          <div dangerouslySetInnerHTML={{ __html: iframeString.value }} />
        </section>
      </Container>
    </Container>
  );
};

export default IframeBlock;
